module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params && _vm.params.isActive) ? _c('ModalDefault', {
    attrs: {
      "size": "s",
      "with-content": true,
      "theme": true,
      "fix-height": false,
      "fix-width": false,
      "loading": false
    },
    on: {
      "close": function($event) {
        _vm.close();
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('p', {
    staticClass: "modal-title mb-4"
  }, [_vm._v("LOG CONTENT")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (_vm.logContentFormatted),
      expression: "logContentFormatted"
    }],
    staticClass: "m-0 log-content"
  })])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc9a66ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/logs/LogContent.vue
// module id = 3368
// module chunks = 0